<template>
  <TimesheetFilter
    @timesheetDataSubmit="checkTimesheetData"
    v-if="(dataSource.status == 'notProcess' || timesheetDetails) && !isLoading"
  />

  <LoadingStatus
    v-else-if="dataSource.status == 'pending' || isLoading"
  ></LoadingStatus>

  <TimesheetGrid
    @showTimesheetDetails="showTimesheetDetails"
    v-else-if="dataSource.status == 'ended' && !timesheetDetails && !isLoading"
  />
</template>

<script>
import TimesheetFilter from "./TimesheetDetails.vue";
import TimesheetGrid from "./TimesheetGrid.vue";
import LoadingStatus from "./LoadingStatus.vue";
// import { mapGetters } from "vuex";

export default {
  title: "Timesheet",
  data() {
    return {
      timesheetDetails: false,
      isLoading: false,
      dataSource: [],
    };
  },
  components: {
    TimesheetFilter,
    TimesheetGrid,
    LoadingStatus,
  },
  methods: {
    showTimesheetDetails() {
      this.timesheetDetails = true;
    },
    checkTimesheetData() {
      this.isLoading = true;
      this.timesheetDetails = false;
      let intervalId = setInterval(() => {
        this.$store.dispatch("timesheet/fetchTimesheet").then((res) => {
          if (res.status == "ended" || res.status == "notProcess") {
            //clear interval
            this.isLoading = false;

            window.clearInterval(intervalId);
            //clear previous intervals in case user refreshes the page while loading
            for (let i = 1; i < 99999; i++) {
              window.clearInterval(i);
            }
          } else {
            this.isLoading = true;
          }
          this.dataSource = res;
        });
      }, 3000);
    },
  },
  mounted() {
    this.$store.dispatch("timesheet/fetchTimesheet").then((res) => {
      this.dataSource = res;
    });
  },
};
</script>
